/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Btn_Resend_Setup_CodeInputs */

const en_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Resend code`)
};

const es_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar código`)
};

const de_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code erneut senden`)
};

const zh_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新发送设置码`)
};

const ar_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إعادة إرسال الرمز`)
};

const fr_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Renvoyer le code`)
};

const vi_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gửi lại mã`)
};

const sw_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tuma msimbo tena`)
};

const th_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ส่งรหัสอีกครั้ง`)
};

const bs_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ponovo pošalji kod`)
};

const ja_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`コードを再送信`)
};

const ko_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`코드 다시 보내기`)
};

const pt_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reenviar código`)
};

const it_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Invia di nuovo il codice`)
};

const sv_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skicka koden igen`)
};

const nl_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code opnieuw verzenden`)
};

const da_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send koden igen`)
};

const nb_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send koden på nytt`)
};

const fi_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lähetä koodi uudelleen`)
};

const pl_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wyślij kod ponownie`)
};

const ru_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отправить код повторно`)
};

const tr_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kodu tekrar gönder`)
};

const hi_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोड दोबारा भेजें`)
};

const id_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kirim ulang kode`)
};

const ms_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hantar semula kod`)
};

const cs_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poslat kód znovu`)
};

const el_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Επαναποστολή κωδικού`)
};

const he_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`שליחת הקוד מחדש`)
};

const af_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Stuur kode weer`)
};

const hu_auth_btn_resend_setup_code = /** @type {(inputs: Auth_Btn_Resend_Setup_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kód újraküldése`)
};

/**
* | output |
* | --- |
* | "Resend code" |
*
* @param {Auth_Btn_Resend_Setup_CodeInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const auth_btn_resend_setup_code = /** @type {((inputs?: Auth_Btn_Resend_Setup_CodeInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Btn_Resend_Setup_CodeInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_auth_btn_resend_setup_code(inputs)
	if (locale === "de") return de_auth_btn_resend_setup_code(inputs)
	if (locale === "zh") return zh_auth_btn_resend_setup_code(inputs)
	if (locale === "ar") return ar_auth_btn_resend_setup_code(inputs)
	if (locale === "fr") return fr_auth_btn_resend_setup_code(inputs)
	if (locale === "vi") return vi_auth_btn_resend_setup_code(inputs)
	if (locale === "sw") return sw_auth_btn_resend_setup_code(inputs)
	if (locale === "th") return th_auth_btn_resend_setup_code(inputs)
	if (locale === "bs") return bs_auth_btn_resend_setup_code(inputs)
	if (locale === "ja") return ja_auth_btn_resend_setup_code(inputs)
	if (locale === "ko") return ko_auth_btn_resend_setup_code(inputs)
	if (locale === "pt") return pt_auth_btn_resend_setup_code(inputs)
	if (locale === "it") return it_auth_btn_resend_setup_code(inputs)
	if (locale === "sv") return sv_auth_btn_resend_setup_code(inputs)
	if (locale === "nl") return nl_auth_btn_resend_setup_code(inputs)
	if (locale === "da") return da_auth_btn_resend_setup_code(inputs)
	if (locale === "nb") return nb_auth_btn_resend_setup_code(inputs)
	if (locale === "fi") return fi_auth_btn_resend_setup_code(inputs)
	if (locale === "pl") return pl_auth_btn_resend_setup_code(inputs)
	if (locale === "ru") return ru_auth_btn_resend_setup_code(inputs)
	if (locale === "tr") return tr_auth_btn_resend_setup_code(inputs)
	if (locale === "hi") return hi_auth_btn_resend_setup_code(inputs)
	if (locale === "id") return id_auth_btn_resend_setup_code(inputs)
	if (locale === "ms") return ms_auth_btn_resend_setup_code(inputs)
	if (locale === "cs") return cs_auth_btn_resend_setup_code(inputs)
	if (locale === "el") return el_auth_btn_resend_setup_code(inputs)
	if (locale === "he") return he_auth_btn_resend_setup_code(inputs)
	if (locale === "af") return af_auth_btn_resend_setup_code(inputs)
	if (locale === "hu") return hu_auth_btn_resend_setup_code(inputs)
	return en_auth_btn_resend_setup_code(inputs)
});